<template>
  <div>
    <common-dialog
      ref="dialog"
      width="750px"
      :show-save-button="false"
      unit="著作出版"
      id-key="ClassId"
      :data="data"
      form-label-width="100px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close="closeFun"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="姓名" prop="TeacherName">
              <el-input
                size="mini"
                v-model="data.TeacherName"
                @focus="onTeacherDialog"
                readonly
                placeholder="点击选择"
                v-if="$permission.canAll(path) && !check"
              ></el-input>
              <span v-else>{{data.TeacherName}}</span>
            </el-form-item>
          </el-col>
        <el-col :span="isMB?24:12">
            <el-form-item label="著作题目" prop="BookName">
              <el-input size="mini" v-model="data.BookName"  placeholder="请填写著作题目" v-if="!check"></el-input>
              <span v-else>{{data.BookName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="出版时间" prop="PublishDate">
                    <el-date-picker
                      size="mini"
                      v-model.trim="data.PublishDate"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      style="width:100%;"
                      v-if="!check"
                    ></el-date-picker>
                    <span v-else>{{$commonJs.toDateString(data.PublishDate)}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="类别" prop="GdCategory">
              <el-select v-model="data.GdCategory" clearable size="mini" style="width:100%;" v-if="!check">
                   <el-option
                        v-for="item in CategoryList"
                        :value="item.DataName"
                        :label="item.DataName"
                        :key="item.DataName"
                   ></el-option>
              </el-select>
              <span v-else>{{data.GdCategory}}</span>
            </el-form-item>
          </el-col>
            <el-col :span="isMB?24:12">
            <el-form-item label="出版社名称" prop="Publisher">
              <el-input size="mini" v-model="data.Publisher" placeholder="请填写出版社名称" v-if="!check"></el-input>
              <span v-else>{{data.Publisher}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="著作出版号" prop="PublishNo">
              <el-input size="mini" v-model="data.PublishNo" placeholder="请填写著作出版号" v-if="!check"></el-input>
              <span v-else>{{data.PublishNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="本人撰写部分" prop="WritePart">
               <el-select v-model="data.WritePart" clearable size="mini" style="width:100%;" v-if="!check">
                   <el-option
                        v-for="item in writeList"
                        :value="item.DataName"
                        :label="item.DataName"
                        :key="item.DataName"
                   ></el-option>
              </el-select>
              <span v-else>{{data.WritePart}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="著作封面照片" prop="CertUrl">
                <el-upload
                  :file-list="uploadFiles"
                  :action="uploadUrl"
                  :headers="header"
                  :data="subData"
                  :on-success="handleSuccess"
                  list-type="picture-card"
                  :on-remove="handleRemove"
                  :on-preview="handlePictureCardPreview"
                  :auto-upload="true"
                  v-if="!check"
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <el-image
                  v-else
                  v-for="(item,index) in uploadFiles"
                  :key="index"
                  style="width: 100px; height: 100px"
                  :src="item.url"
                  :fit="fit"
                  @click="handlePictureCardPreview(item)">
                </el-image>
 
                <el-dialog title="查看图片" :visible.sync="dialogVisible" :append-to-body="true">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
            </el-form-item>
          </el-col>

        </el-row>
      </template>
      <template slot="footer">
        <el-button size="mini" type="primary" @click="examineDiary" v-if="isOpen">审批日志</el-button>
        <el-button size="mini" type="primary" @click="diaryEdit" v-if="isOpen">修改日志</el-button>
        <el-button size="mini" type="success" v-if="!isEdit && !check" @click="()=>{save()}">保存</el-button>
        <el-button size="mini" type="primary" v-if="(data.Status==0 || data.Status==2) && !check" @click="()=>{Submit()}">提交</el-button>
        <el-button size="mini" type="primary" @click="examine" v-if="isEdit">通过</el-button>
        <el-button size="mini" type="danger" @click="cancelExamine" v-if="isEdit">退回</el-button>
        <el-button size="mini" @click="close" >关 闭</el-button>
      </template>
    </common-dialog>
      <teacher-dialog
        ref="teacherDialog"
        in-dialog
        selectable
        :multiple="false"
        @select="setTeacher"
      />
      <details-dialog ref="detailsDialog" @close-saved="()=>{$emit('close-saved'),save(),close(1)}"></details-dialog>
      <diary-dialog ref="diaryDialog" @close-saved="()=>{$emit('diary-saved'),close(1)}"></diary-dialog>
       <examine-dialog ref="examineDialog" @close-saved="()=>{$emit('diary-saved'),close(1)}"></examine-dialog>
  </div>
</template>
<script>
import examineDialog from "@/components/gd/scientific/list3/examineDialog";
import diaryDialog from "@/components/gd/scientific/list3/diaryDialog";
import detailsDialog from "@/components/gd/scientific/list3/detailsDialog";
import teacherDialog from "@/components/fa/teacher/listDialog";
import importFile from "@/components/common/files/importFile";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";
import router from '@/router'
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

export default {
  props: {
    ThemeLvList: {
      type: Array,
      default: [],
    },
    CategoryList: {
      type: Array,
      default: [],
    },
    writeList: {
      type: Array,
      default: [],
    },
  },
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
    teacherDialog,
    detailsDialog,
    diaryDialog,
    examineDialog
  },
  data() {
    return {
      path:router.history.current.path,
      data: {
        BookId:0,
        TeacherId:JSON.parse(localStorage.getItem("loginInfo")).TeacherId,
        TeacherName:JSON.parse(localStorage.getItem("loginInfo")).UserName,    
        BookName: "",
        PublishDate: "",
        GdCategory: "",
        PublishNo: "",
        Publisher:"",
        CoverUrl: "",
        WritePart:"",
        Status:0,
      },
      uploadUrl: "/api/Common/UploadPicture",
      uploadFiles: [],
      dialogImageUrl: "",
      dialogVisible: false,
      uploadedFiles:[],
      files:[],
      subData: {
        dic: 'Gd',
      },
      api: require("@/api/gd/book").default,
      Base_api: require("@/api/gd/basedata").default,
      gradeApi: require("@/api/ed/grade").default,
      termApi,
      isMB: this.$store.state.isMB,
      // gradeList: [],
      termList: [],
      isEdit: false,
      isOpen:false,
      check:false,
      rules: {
        BookName: [{ required: true, message: "请填写著作题目" }],
        TeacherName: [{ required: true, message: "请选择人员" }],
        Publisher: [{ required: true, message: "请输入出版社名称" }],
        PublishDate: [{ required: true, message: "请选择承担时间" }],
        GdCategory: [{ required: true, message: "请选择类别" }],
        GdLv: [{ required: true, message: "请选择级别" }],
        PublishNo: [{ required: true, message: "请填写著作出版号" }],
      },
    };
  },
  computed: {
    header() {
      let token = localStorage.getItem("token");
      if (token) {
        return { Authorization: "Bearer " + token };
      }
      return {};
    },
  },
  methods: {
      closeFun(){
       this.uploadFiles=[]
      },
        //上传成功回调
    handleSuccess(res, file, fileList) {
      console.log("success");
    
      if (res.Code == 0) {
        if (fileList.length > 0) {
            this.uploadFiles = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
            this.data.CoverUrl=this.uploadFiles[0].response.Data
              console.log(this.uploadFiles);
        }
        this.$message.success(res.Msg);
      } else {
        if (res.Code == 2) {
          this.$message.error(res.Msg);
        } else {
          this.$message.error(res.Msg);
        }
        this.uploadFiles = this.uploadFiles.concat();
      }
    },
    onCreateOpened(){
         this.uploadFiles=[]
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.uploadFiles = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploaded(res) {
      console.log("uploaded", res);
      if (res.Code != 0) {
        this.$message.error(res.Msg);
      } else {
        this.$emit("upload-success");
      }
    },
    handleSelect(item) {
      console.log(item);
      this.data.WritePart=item.value
    },
    querySearchAsync(queryString, cb) {
      var writeList = this.writeList;
      var results = queryString ? writeList.filter(this.createStateFilter(queryString)) : writeList;
        cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    examineDiary(){
       this.$refs.examineDialog.openEdit({RecordId:this.data.BookId,MenuName:'著作出版管理',Gd:true});
    },
    diaryEdit(){
       this.$refs.diaryDialog.openEdit({RecordId:this.data.BookId,MenuName:'著作出版管理'});
    },
    Submit(){
      this.$refs.dialog.formValidate().then((valid) => {
          if (!valid) {
            return;
          }
        this.$refs.dialog.isLoading = true;
        this.api.submit(this.data).then(res => {
          this.$refs.dialog.isLoading = false;
          if(res.Code ==0) {
            this.$message.success(res.Msg)
            this.readonly = true
            this.close(1)
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
        examine() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
         this.save()
        this.api.examine(this.data.BookId).then(res => {
          if(res.Code ==0) {
            this.$message.success(res.Msg)
            this.readonly = true
            this.close(1)
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      sessionStorage.setItem('cancel','3')
      this.$refs.detailsDialog.openEditById(this.data.BookId);
    },
    // cancelExamine() {
    //   this.$confirm("确认退回吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //   .then(() => {
    //     this.api.cancelExamine(this.data.BookId).then(res => {
    //       if(res.Code ==0) {
    //         this.$message.success(res.Msg)
    //         this.readonly = false
    //         this.close()
    //         this.$emit("close-saved")
    //       } else {
    //         this.$message.error(res.Msg)
    //       }
    //     })
    //   })
    // },
    setTeacher(t) {
      this.data.TeacherId = t.TeacherId;
      this.data.TeacherName = t.TeacherName;
    },
    onTeacherDialog() {
      this.$refs.teacherDialog.open().then((that) => {
        that.getData();
      });
    },
    uploaded(res, fileList) {
      console.log("uploaded", res, fileList);
      this.fileList = fileList;
      this.data.CertUrl=res.Data.VirtualPath
      this.data.CertName=res.Data.FileName+'.'+res.Data.Extension
    },
    onCreateOpened() {
      this.isEdit = false;
      this.isOpen=false;
      this.check = false;
      // this.data.TermId = loginInfo.TermId;
      // this.getOption()
    },
    onEditOpened(row) {
      this.isOpen=true
      if(sessionStorage.getItem('check')==='1') {
        this.isEdit = true;
        this.check = false;
        sessionStorage.removeItem('check')
      }else if(sessionStorage.getItem('check')==='2') {
        this.isEdit = false;
        this.check = true;
        sessionStorage.removeItem('check')
      }  else {
        this.check = false;
        this.isEdit = false;
      }
      if(this.data.CoverUrl){
      this.uploadFiles=[{
              url:"/api" + this.data.CoverUrl,
            }]
      }
    },

  },
};
</script>
<style lang="scss">
    .el-upload-list__item {
      transition: none !important;
    }
</style>